import * as angular from "angular";
import {GroupColor} from "../constants/group-color";
import {GroupsService} from "./groups.service";

export class GroupsDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private groupsService: GroupsService) {
  }

  createGroup(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/group-form-dialog.html').default,
      controller: function ($scope) {

        $scope.group = {};
        $scope.header = 'Create Group';
        $scope.groupColors = GroupColor;


        $scope.cancel = self.$mdDialog.cancel;

        $scope.onBranchesSelect = (branchIds: string[]) => {
          $scope.group.branchIds = branchIds;
        }

        $scope.onGroupColorSelect = (event, color) => {
          $scope.group.displayColor = color;
        }

        $scope.onTagsChange = (tags: string[]) => {
          $scope.group.tags = tags;
        }

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.group);
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  editGroup(group, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/group-form-dialog.html').default,
      controller: function ($scope) {

        $scope.group = group;
        $scope.header = 'Edit Group'
        $scope.groupColors = GroupColor;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onBranchesSelect = (branchIds: string[]) => {
          $scope.group.branchIds = branchIds;
        }

        $scope.onGroupColorSelect = (event, color) => {
          $scope.group.displayColor = color;
        }

        $scope.onTagsChange = (tags: string[]) => {
          $scope.group.tags = tags;
        }

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.group);
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  deleteGroup(group, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/delete-group-dialog.html').default,
      controller: function ($scope) {

        $scope.group = group;

        $scope.selectedGroupToMoveToId = undefined;
        $scope.cancel = self.$mdDialog.cancel;

        $scope.onGroupIdChange = (groupId: string) => {
          $scope.selectedGroupToMoveToId = groupId;
        }

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({group: $scope.group, selectedGroupToMoveToId: $scope.selectedGroupToMoveToId});
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  addBranchesToGroup(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/add-branches-to-group.html').default,
      controller: function ($scope) {

        $scope.selectedGroupToMoveToId = undefined;
        $scope.isCreateNewGroup = false;
        $scope.createGroup = {};
        $scope.cancel = self.$mdDialog.cancel;

        $scope.onGroupIdChange = (groupId: string) => {
          $scope.selectedGroupToMoveToId = groupId;
        }

        $scope.onToggleIsCreateButton = (isCreateNewGroup) => {
          $scope.isCreateNewGroup = isCreateNewGroup;
        }

        $scope.onCreateGroupChange = (createGroup) => {
          $scope.createGroup = angular.copy(createGroup);
        }

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              if ($scope.isCreateNewGroup) {
                self.groupsService.createGroup($scope.createGroup)
                  .then((group) => {
                    self.$mdDialog.hide(group.id);
                  })
              } else {
                self.$mdDialog.hide($scope.selectedGroupToMoveToId);
              }
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  addGroups(selectedIds: string[], isRequired?:boolean, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/add-groups-dialog.html').default,
      controller: function ($scope) {

        $scope.selectedIds = selectedIds;
        $scope.isRequired = isRequired;
        $scope.cancel = self.$mdDialog.cancel;

        $scope.onGroupIdsChange = (groupIds: string[]) => {
          $scope.selectedIds = groupIds;
        }

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.selectedIds);
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }
}

angular
  .module('bringoz.admin.groups')
  .service('groupsDialogService', GroupsDialogService);
